import { type ReactNode, useEffect } from 'react';
import { init as initAmplitude, Types } from '@amplitude/analytics-browser';
import { initAirbridge } from '@banhala/utils';

/**
 * Amplitude 브라우저 SDK.
 *
 * 이벤트 로깅은 여전히 inhouseLogger 가 담당한다. 이 SDK 를 초기화하는 목적은 **web device
 * id 를 확보하는 것**이다. 앱으로 보내는 딥링크에 그 값을 `web_did` 로 실어야 앱이
 * `SEND_SYNTHETIC_MERGE` 로 웹 비회원과 앱 회원을 한 유저로 통합할 수 있다
 * (`shared/src/utils/addWebDidToDeeplink`).
 *
 * SDK 는 쿠키를 최상위 도메인에 저장하므로 `m.a-bly.com`(웹뷰 iframe)과 `mobile.a-bly.com`
 * 이 같은 device id 를 공유한다. 그래서 어느 쪽에서 시작한 세션이든 같은 값으로 병합된다.
 */
const initAmplitudeSdk = () => {
  const apiKey = import.meta.env.VITE_AMPLITUDE_KEY;

  // 키가 없으면 device id 는 생기지만 전송이 전부 실패한다. 조용히 반쯤 동작하는 상태를
  // 만들지 않도록 아예 초기화하지 않는다.
  if (apiKey == null || apiKey === '') {
    if (__DEV__) {
      console.warn(
        '[ThirdPartyInitProvider] VITE_AMPLITUDE_KEY 가 없어 Amplitude 를 초기화하지 않습니다. web_did 병합이 동작하지 않습니다.',
      );
    }
    return;
  }

  // userId 는 넘기지 않는다. 웹 로그인 상태를 이 시점에 동기로 알 수 없고, 병합에 필요한 건
  // device id 뿐이다(user_id 는 앱이 자기 세션에서 붙인다).
  initAmplitude(apiKey, undefined, { logLevel: Types.LogLevel.Warn });
};

export const ThirdPartyInitProvider: React.FC<{
  children: ReactNode;
}> = props => {
  useEffect(() => {
    initAirbridge();
    initAmplitudeSdk();
  }, []);
  return <>{props.children}</>;
};